/*jshint unused:false*/
/*global fetch */
/*global console */



// $(function () {

// /**** NAV SCROLL ****/
//     $(".side-nav a, .header-intro a, .footer-content a").click(function(e){
//         e.preventDefault();
//         // Hide nav
//         // Scroll to location
//         $("html, body").animate({ 
//             scrollTop: $( $(this).attr('href') ).position().top+50
//         }, 600);
//     });

// });

//object fit fix for ie11
var userAgent, ieReg, ie;
userAgent = window.navigator.userAgent;
ieReg = /msie|Trident.*rv[ :]*11\./gi;
ie = ieReg.test(userAgent);


if(ie) {
  var imgContainer = document.querySelectorAll(".img-container");

  for(var i=0; i<imgContainer.length; i++){
    var imgCtr = imgContainer[i];
    var imgUrl = imgCtr.getElementsByTagName("img")[0].src;
    if (imgUrl) {
      imgCtr.setAttribute("style", "background-image:url('" + imgUrl + "')");
      imgCtr.classList.add("custom-object-fit");
    }
  }
}

// Back to top button
const scrollToTopButton = document.getElementById('back_to_top');
let smoothScrollCapture = (x) => {
  event.preventDefault();
  let id = x.currentTarget.target.getAttribute('href').split("#")[1]
  let el = document.getElementById(id);
  var x = el.getBoundingClientRect().left;
  var y = el.getBoundingClientRect().top;
  smoothScrollFunc(x, y)
}
let smoothScrollFunc = (x, y) => {
  event.preventDefault();
  window.scrollTo({
    top: y,
    left: x,
    behavior: 'smooth'
  });
}
window.addEventListener('DOMContentLoaded', () => {
  scrollToTopButton.addEventListener('click', () => {
    smoothScrollFunc(0, 0);
  })
})

window.addEventListener('scroll', () => {
  let pageHeight = document.body.scrollHeight;
  let currentHeight = window.scrollY;
  (currentHeight > (pageHeight/2)) ? scrollToTopButton.classList.add('active') : scrollToTopButton.classList.remove('active');
})
// End back to top button

// Price toggles
let allSwitches = [].slice.call(document.querySelectorAll('.price-toggle'));
let priceContainers = [].slice.call(document.querySelectorAll('.deal-price-toggle'));
let priceSwitchForm = document.getElementById('price-switch');
let selected;
function priceToggles() {
  allSwitches.forEach((value) => {
    // value.addEventListener('click', (e) => {
    //
    // });
    value.addEventListener('change', (val) => {
      (val.composedPath()[0].classList.contains('toggle-personal')) ? selected = 0 : selected = 1;
      if(val.composedPath()[0].classList.contains('price-toggle-checkbox')){
        (val.target.checked === true) ? selected = 1 : selected = 0;
      }
      toggleSwitches();
      togglePrices();
      updatePrice();
      manufacturerStrip();
    })
  })
  let toggleSwitches = () => {
    allSwitches.forEach((v) => {
      (selected === 0) ? v.querySelectorAll('.toggle-personal').forEach((v) => { v.checked = true }) : v.querySelectorAll('.toggle-business').forEach((v) => { v.checked = true });
      (selected === 0) ? document.querySelectorAll('.price-toggle-checkbox').forEach((v) => { v.checked = false }) : document.querySelectorAll('.price-toggle-checkbox').forEach((v) => { v.checked = true });
    })
    document.querySelector("#switch-price-type").value = (selected === 0) ? 'Personal' : 'Business';
    document.querySelectorAll(".price-title-type").forEach((v) => {
      v.innerHTML = (selected === 0) ? 'Personal' : 'Business';
    })
  }
  let togglePrices = () => {
    priceContainers.forEach((v) => {
      (selected === 0) ? v.querySelector('.price-personal').classList.add('active') : v.querySelector('.price-personal').classList.remove('active');
      (selected === 1) ? v.querySelector('.price-business').classList.add('active') : v.querySelector('.price-business').classList.remove('active');
    })
  }
  let manufacturerStrip = () => {
    if(document.querySelector('.manufacturer-strip-cars')){
      (selected === 0) ? document.querySelector('.manufacturer-strip-cars').classList.add('active') : document.querySelector('.manufacturer-strip-cars').classList.remove('active');
      (selected === 1) ? document.querySelector('.manufacturer-strip-vans').classList.add('active') : document.querySelector('.manufacturer-strip-vans').classList.remove('active');
    }
    if(document.querySelector('.manufacturer-strip a[title="View All Manufacturers"]')){
      (selected === 0) ? document.querySelector('.manufacturer-strip a[title="View All Manufacturers"]').setAttribute('href', '/car-leasing/manufacturers') : null;
      (selected === 1) ? document.querySelector('.manufacturer-strip a[title="View All Manufacturers"]').setAttribute('href', '/van-leasing/manufacturers') : null;
    }
  }
  let updatePrice = () => {
    let url = priceSwitchForm.getAttribute('action');
    let formData = new FormData(priceSwitchForm);
    fetch(url, {
      method: 'POST',
      processData: false,
      contentType: false,
      body: formData,
      headers: {
        'X-CSRF-TOKEN': document.querySelector("#price-switch [name=_token]").value,
        'X-Requested-With': 'XMLHttpRequest'
      },
    }).then(
      function(response) {
        if (response.status !== 200) {
          console.log('Looks like there was a problem. Status Code: ' + response.status);
          return;
        }
        response.json().then(function(data) {
          document.querySelector("#price-switch [name=_token]").value = data.token;
        });
      }
    ).catch(function(err) {
      console.log('Fetch Error :-S', err);
    });
  }
}
priceToggles();
// End price Toggles


//Nav Toggle
function toggleNav(el) {
    var element = el;
    var menu = document.getElementById("site-menu");
    var header = document.querySelectorAll(".site-header")[0];
    menu.classList.toggle("active");
    header.classList.toggle("active");

    if(element.querySelector("span").classList.contains("more")){
      element.innerHTML = "<span class='close'></span> Close";
    } else {
      element.innerHTML = "<span class='more'></span> Menu";
    }
}

// //Accordion active
// var showAccordion = function(){
//     var dropdown = this.parentNode;
//     dropdown.classList.toggle("active");
// }
//
// var accordionButton = document.querySelectorAll(".accordion > button");
//
// for(var i=0; i<accordionButton.length; i++){
//   accordionButton[i].addEventListener('click', showAccordion, false);
// }

// // Mobile Dropdown
// var mobileDropdown = function(){
//     var dropdown = this.parentNode;
//     dropdown.classList.toggle("active");
// }

// var mobile_dropdown = document.querySelectorAll(".breadcrumb-menu");

// for(var i=0; i<mobile_dropdown.length; i++){
//   mobile_dropdown[i].addEventListener('click', mobileDropdown, false);
// }

/* MOBILE MODALS */
const navContainer = document.querySelector('.nav-container');
const hamburger = document.querySelector('#hamburger');
const hamburgerSearch = document.querySelector('#headerSearch');

const modalMobileNav = new tingle.modal({
  footer: true,
  closeMethods: ['escape'],
  cssClass: ['mobile-nav','reversed'],
  onOpen: function () {
    // Navigation height
    let headerHeight = 0;
    if (document.querySelector('.site-header').classList.contains('is-sticky')) {
      headerHeight = document.querySelector('.site-header').offsetHeight + document.querySelector('.top-bar').offsetHeight;
    } else {
      headerHeight = document.querySelector('.site-header').offsetHeight + document.querySelector('.top-bar').offsetHeight + (document.body.getBoundingClientRect().top + window.scrollY);
    }
    document.querySelector('.mobile-nav.tingle-modal').setAttribute('style', `margin-top:${headerHeight}px;height:calc(100vh - ${headerHeight}px)!important`);
    document.querySelector('.site-menu') ? modalMobileNav.setFooterContent(document.querySelector('#price-switch').outerHTML) : null;
    priceToggles();
  }
});
document.querySelector('.site-menu') ? modalMobileNav.setContent(document.querySelector('.site-menu').innerHTML) : null;

// Nav modal
const handleToggle = () => {
  hamburger.classList.toggle('active');
  hamburger.classList.toggle('is-active');
  navContainer.classList.toggle('is-active');
  // hamburger.parentElement.classList.toggle('active');

  if(hamburger.classList.contains("active")) {
    // modalMobileSearch.close();
    modalMobileNav.open();
  } else{
    modalMobileNav.close();
  }
}

hamburger.onclick = () => handleToggle();
hamburger.addEventListener('keyup', (event) => {
  if(event.keyCode === 13 || event.keyCode === 32) {
    handleToggle();
  }
});
/* END MOBILE MODALS */


// Search Bar
var searchDropdown = function(){
    var searchRow = this.closest('.search-bar');
    searchRow.classList.toggle("active");
}

var searchBar = document.querySelectorAll(".search-bar .legend");

for(var i=0; i<searchBar.length; i++){
  searchBar[i].addEventListener('click', searchDropdown, false);
}


if(document.getElementsByClassName('toggle-search').length>0){
  document.getElementsByClassName('toggle-search')[0].addEventListener('click', function(e){
    e.preventDefault();
    if(document.querySelector('#popout-form')===null){
      window.location.href='/search';
      return false;
    }
    if(document.querySelector('#popout-form').classList.contains('hidden')){
      document.querySelector('#popout-form').classList.remove('hidden');
    } else {
      document.querySelector('#popout-form').classList.add('hidden');
    }
  });
}

const searchSorter = document.querySelector('#search-sorter');
if (searchSorter) {
  searchSorter.addEventListener('change', (e) => {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set('order', e.target.value);
    window.location.search = urlParams;
  })
}

const searchReset = document.querySelector('.search-form .search-buttons button.button-reset');
if (searchReset) {
  const allFields = document.querySelectorAll('.search-form .form-group select');
  searchReset.addEventListener('click', (e) => {
    document.querySelector('.search-form').reset();
    allFields.forEach(value => {
      value.selectedIndex = 0;
      loadModels();
      loadSpecs();
    })
  })
}

// Show More
const showMoreButton = document.querySelector('#show-more');
const headerContent = document.querySelector('#manufacturer-header-content');
if(showMoreButton){
  if (showMoreButton.parentElement.querySelectorAll('.header-description > *').length > 1) {
    showMoreButton.addEventListener('click', (e) => {
      console.log('click')
      headerContent.classList.toggle('header-content--full');
      showMoreButton.classList.toggle('active');
      (showMoreButton.classList.contains('active')) ? showMoreButton.querySelector('span').innerText = 'Show less' : showMoreButton.querySelector('span').innerText = 'Read more';
    })
  } else {
    showMoreButton.classList.add('visuallyhidden')
  }
}


//Menu Dropdown Toggle
// var menuDropdown = function(){
//     var dropdown = this;
//     dropdown.classList.toggle("active");
// }

// var menuTrigger = document.querySelectorAll(".menu-dropdown");

// for(var i=0; i<menuTrigger.length; i++){
//   menuTrigger[i].addEventListener('click', menuDropdown, false);
// }

// //Dropdown Button
// var showDropdown = function(){
//     var dropdown = this.parentNode;
//     dropdown.classList.toggle("active");
// }

// var dropdownButton = document.querySelectorAll(".dropdown > button");

// for(var i=0; i<dropdownButton.length; i++){
//   dropdownButton[i].addEventListener('click', showDropdown, false);
// }

// //Dropdown Toggle
// var showDropdown = function(){
//     var dropdown = this.querySelector('div');
//     dropdown.classList.toggle("active");
// }

// var has_dropdown = document.querySelectorAll(".has-dropdown");

// for(var i=0; i<has_dropdown.length; i++){
//   has_dropdown[i].addEventListener('click', showDropdown, false);
// }

// // Mobile Dropdown
// var mobileDropdown = function(){
//     var dropdown = this.parentNode;
//     dropdown.classList.toggle("active");
// }

// var mobile_dropdown = document.querySelectorAll(".breadcrumb-menu");

// for(var i=0; i<mobile_dropdown.length; i++){
//   mobile_dropdown[i].addEventListener('click', mobileDropdown, false);
// }


// Site Search Toggle
// var searchToggle = function(){
//   search_container = document.querySelector(".popout-form");
//   if(search_container){
//     search_container.classList.toggle("active");
//   } else {
//     var elmnt = document.querySelector(".full-header-search");
//     elmnt.scrollIntoView();
//   }
// }

// var search_toggle = document.getElementById('search-toggle');
// search_toggle.addEventListener('click', searchToggle , false);



//Site Menu Dropdown Toggle
var menuDropdown = function(){
    //div inside element contains dropdown menu
    var dropdown = this.parentNode;

    //if it's already active set it not to be
    if(dropdown.classList.contains("active")){
        dropdown.classList.toggle("active");
        return;
    }
    //get current active class
    var activeClass = document.querySelectorAll(".menu-dropdown.active");
    // make it not active
    if(activeClass!=null){
        for(var i=0; i<activeClass.length; i++){
          activeClass[i].classList.toggle("active");
        }
    }
    
    //apply active to the div inside element that contains dropdown menu
    dropdown.classList.toggle("active");
}

var dropdownTrigger = document.querySelectorAll(".menu-dropdown > a");

for(var i=0; i<dropdownTrigger.length; i++){
  dropdownTrigger[i].addEventListener('click', menuDropdown, false);
}


// //Menu Dropdown Toggle
// var menuDropdown = function(){
//     //div inside element contains dropdown menu
//     var dropdown = this.parentNode.querySelector(".menu-dropdown");

//     //if it's already active set it not to be
//     if(dropdown.classList.contains("active")){
//         dropdown.classList.toggle("active");
//         return;
//     }
//     // //get current active class
//     // var activeClass = document.querySelectorAll(".menu-dropdown.active");
//     // // make it not active
//     // if(activeClass!=null){
//     //     for(var i=0; i<activeClass.length; i++){
//     //       activeClass[i].classList.toggle("active");
//     //     }
//     // }
    
//     //apply active to the div inside element that contains dropdown menu
//     dropdown.classList.toggle("active");
// }

// var menuTrigger = document.querySelectorAll(".menu-dropdown > a");

// for(var i=0; i<menuTrigger.length; i++){
//   menuTrigger[i].addEventListener('click', menuDropdown, false);
// }


//Dropdown Menu Toggle
const showMenu = function(){
  let allMenuToggles = this.parentElement.parentElement.querySelectorAll('.dropdown-menu > a');
  let allDropdowns = this.parentElement.parentElement.querySelectorAll('.dropdown-menu > .dropdown');
  let menuToggle = this;
  let dropdown = this.nextElementSibling;

  allMenuToggles.forEach((value) => {
    if (value !== menuToggle) {
      value.classList.remove("active");
      value.classList.remove("is-active");
    } else {
      menuToggle.classList.toggle("active");
      menuToggle.classList.toggle("is-active");
    }
  })

  allDropdowns.forEach((value) => {
    if (value !== dropdown) {
      value.classList.remove("active");
      value.classList.remove("is-active");
    } else {
      dropdown.classList.toggle("active");
      dropdown.classList.toggle("is-active");
    }

  })
}
document.querySelectorAll(".dropdown-menu > a").forEach((value) => {
  value.addEventListener('click', showMenu, false);
})

var menuDropdown = document.querySelectorAll(".dropdown-menu > a");

for(var i=0; i<menuDropdown.length; i++){
  menuDropdown[i].addEventListener('click', showMenu, false);
}

// Toggle class for accordions
let acc = document.getElementsByClassName('mobile-accordion-header');
for (let i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function(ev) {

    for (let i = 0; i < acc.length; i++) {
      if (acc[i] === this || acc[i].parentElement.parentElement !== this.parentElement.parentElement || this.parentElement.classList.contains('no-close')) {
        continue;
      }
      acc[i].parentElement.classList.remove('active');
    }

    if (!this.parentElement.classList.contains('active') && !this.parentElement.classList.contains('no-scroll')){
      setTimeout(() => { document.documentElement.scrollTop += this.getBoundingClientRect().top; }, 500);
    }
    this.parentElement.classList.toggle("active");

  });
}

//Dropdown Menu Toggle
// var mobileDropdown = function(){
//   //div inside element contains dropdown menu
//   var dropdown = this.parentNode.querySelector('div');


//   //if it's already active set it not to be
//     if(dropdown.classList.contains("active")){
//         dropdown.classList.toggle("active");
//         return;
//     }
//     //get current active class
//     var activeClass = document.querySelectorAll(".mobile-dropdown .active");
//     // make it not active
//     if(activeClass!=null){
//         for(var i=0; i<activeClass.length; i++){
//           activeClass[i].classList.toggle("active");
//         }
//     }

  
//   //apply active to the div inside element that contains dropdown menu
//   dropdown.classList.toggle("active");
// }

// var mobileMenu = document.querySelectorAll(".mobile-dropdown > a");

// for(var i=0; i<mobileMenu.length; i++){
//   mobileMenu[i].addEventListener('click', mobileDropdown, false);
// }



//faqs
var faqSearch = document.querySelector('.faq-search input');

if(faqSearch !== null){
  faqSearch.addEventListener('keyup', function(e){
    var results = document.getElementById('faq-results');
    if(this.value.length != 0){
      results.classList.add("active");
    } else {
      results.classList.remove("active");
    }
  });
}


//More Options Toggle
var classname = document.querySelectorAll(".more-options");

var moreOptions = function(e) {
	e.preventDefault();
  var element = document.getElementById("vehicle-search");
  element.classList.toggle("active");
  if(element.classList.contains('active')){
    this.innerHTML = 'Hide additional options';
  } else {
    this.innerHTML = 'Show me more options';
  }
};

for (var i = 0; i < classname.length; i++) {
    classname[i].addEventListener('click', moreOptions, false);
}

//Tab Content
function openTab(e, tabName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tab-content");
  tablinks = document.getElementsByClassName("tab");

  //remove active tab
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].className = tabcontent[i].className.replace(" active", "");
  }

  //remove active from button tabs
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  //add active to tab
  document.getElementById(tabName).className += " active";

  //add active to button tabs
  e.currentTarget.className += " active";
}

//Search for Cars or Vans
function showDesc(el){
  el.style.display = 'none';
  el.parentNode.querySelector('.extra').classList.remove('visuallyhidden');
}






/** 
  * SEARCH
  */
function searchType(elem, searchType) {
  let hiddenField, searchTab;

  //set hidden field value
  hiddenField = document.getElementById("search-type");
  hiddenField.setAttribute('value', searchType);

  //remove active class
  searchTab = document.getElementsByClassName("search-tab");
  for (i = 0; i < searchTab.length; i++) {
    searchTab[i].className = searchTab[i].className.replace(" active", "");
  }

  //add active class to clicked
  elem.classList.toggle("active");

  loadManufacturers(document.querySelector('#search-type').value);
  loadBodyTypes(document.querySelector('#search-type').value, true);

  var dropdown = document.getElementsByName('model')[0];
  dropdown.length = 0;

  var defaultOption = document.createElement('option');
  defaultOption.text = 'Any Model';
  defaultOption.value = '';

  dropdown.add(defaultOption);
  dropdown.selectedIndex = 0;
}
if (document.querySelector('.search-tab.active')){
  setTimeout(() => { document.querySelector('.search-tab.active').dispatchEvent(new Event('click')) }, 500)
}


function loadManufacturers($type) {
  if ($type) {
    let defaultOption = document.createElement('option');
    defaultOption.text = 'Any Make';
    defaultOption.value = '';
    let loadingOption = document.createElement('option');
    loadingOption.text = 'Loading...';
    loadingOption.value = '';
    let loadingError = document.createElement('option');
    loadingError.text = 'Loading Error, please check your internet connection';
    loadingError.value = '';
    document.querySelectorAll('[name="make"]').forEach((v, i) => {
      v.length = 0;
      v.add(loadingOption);
      v.selectedIndex = 0;
      let url = '/api/'+$type+'/manufacturers';
      fetch(url).then(function(response) {
        if (response.status !== 200) {
          console.warn('Looks like there was a problem. Status Code: ' + response.status);
          return;
        }
        return response.json();
      }).then(function(data) {
        let keysSorted = Object.keys(data).sort(function(a, b) {
          return data[a].localeCompare(data[b])
        });
        v.length = 0;
        v.add(defaultOption);
        v.selectedIndex = 0;
        for (let x in keysSorted) {
          let option = document.createElement('option');
          option.text = data[keysSorted[x]].toUpperCase();
          option.value = keysSorted[x];
          v.add(option);
        }
      }).catch(function(err) {
        console.error('Fetch Error -', err);
      });
    })
  }
}

function loadModels($type, $manufacturer) {
  if ($type && $manufacturer) {
    let defaultOption = document.createElement('option');
    defaultOption.text = 'Any Model';
    defaultOption.value = '';
    let loadingOption = document.createElement('option');
    loadingOption.text = 'Loading...';
    loadingOption.value = '';
    let loadingError = document.createElement('option');
    loadingError.text = 'Loading Error, please check your internet connection';
    loadingError.value = '';

    var model_dropdowns = document.getElementsByName("model");
    for (let i = 0; i < model_dropdowns.length; i++) {
      var dropdown = model_dropdowns[i];
      dropdown.length = 0;
      dropdown.add(defaultOption);
      dropdown.selectedIndex = 0;

      if ($manufacturer) {
        dropdown.length = 0;
        dropdown.add(loadingOption);
        dropdown.selectedIndex = 0;

        var url = '/api/'+$type+'/models/'+$manufacturer;

        fetch(url).then(function(response) {
          if (response.status !== 200) {
            console.warn('Looks like there was a problem. Status Code: ' +
              response.status);
            return;
          }
          return response.json();
        }).then(function(data) {
          dropdown.length = 0;
          dropdown.add(defaultOption);
          dropdown.selectedIndex = 0;
          let keysSorted = Object.keys(data).sort(function(a, b) {
            return data[a].localeCompare(data[b])
          });
          for (let x in keysSorted) {
            let option = document.createElement('option');
            option.text = data[keysSorted[x]];
            option.value = keysSorted[x];
            dropdown.add(option);
          }
          const urlParams = new URLSearchParams(window.location.search);
          const makeParam = urlParams.get('make');
          const modelParam = urlParams.get('model');
          if (modelParam && makeParam == $manufacturer) {
            dropdown.value = modelParam;
            loadSpecs($type, modelParam);
          }
        }).catch(function(err) {
          dropdown.length = 0;
          dropdown.add(loadingError);
          dropdown.selectedIndex = 0;
          console.error('Fetch Error -', err);
        });
      }
    }
  }
}

function loadBodyTypes($type, $van_sizes = false) {
  let dropdown = document.querySelector('[name=body_type]');
  if (!dropdown) {
    dropdown = document.querySelector('[name=van_size]');
  }
  if (dropdown && $type) {
    let defaultOption = document.createElement('option');
    defaultOption.text = 'Any Bodytype';
    defaultOption.value = '';
    let loadingOption = document.createElement('option');
    loadingOption.text = 'Loading...';
    loadingOption.value = '';
    let loadingError = document.createElement('option');
    loadingError.text = 'Loading Error, please check your internet connection';
    loadingError.value = '';
    dropdown.length = 0;

    dropdown.length = 0;
    dropdown.add(loadingOption);
    dropdown.selectedIndex = 0;

    let url = '/api/'+$type+'/types';

    fetch(url).then(function(response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' +
          response.status);
        return;
      }
      return response.json();
    }).then(function(data) {
      dropdown.length = 0;
      dropdown.add(defaultOption);
      dropdown.selectedIndex = 0;
      let keysSorted = Object.keys(data).sort(function(a, b) {
        return data[a].localeCompare(data[b])
      });
      if ($van_sizes && $type === 'van') {
        dropdown.setAttribute('name', 'van_size');
        let van_sizes = { "small": "Small", "medium": "Medium", "large": "Large", "pickup": "Pickup" };
        Object.entries(van_sizes).forEach(([key, value]) => {
          let option = document.createElement('option');
          option.text = value;
          option.value = key;
          dropdown.add(option);
        });
      } else {
        dropdown.setAttribute('name', 'body_type');
        for (let x in keysSorted) {
          let option = document.createElement('option');
          option.text = data[keysSorted[x]];
          option.value = keysSorted[x];
          dropdown.add(option);
        }
      }
    }).catch(function(err) {
      dropdown.length = 0;
      dropdown.add(loadingError);
      dropdown.selectedIndex = 0;
      console.error('Fetch Error -', err);
    });
  }
}

function loadSpecs($type, $model) {

  var dropdown = document.getElementsByName('spec_level')[0];
  dropdown.length = 0;

  var defaultOption = document.createElement('option');
  defaultOption.text = 'Any Spec';
  defaultOption.value = '';

  dropdown.add(defaultOption);
  dropdown.selectedIndex = 0;

  if ($type && $model) {
    let url = '/api/'+$type+'/specs/'+$model;

    fetch(url).then(function(response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' +
          response.status);
        return;
      }
      return response.json();
    }).then(function(data) {
      for (var x in data) {
        var option = document.createElement('option');
        option.text = data[x];
        option.value = x;
        dropdown.add(option);
      }
    }).catch(function(err) {
      console.error('Fetch Error -', err);
    });
  }

}


// document.getElementById('email-signup').addEventListener("click", function(e) {
//   e.preventDefault();
    
//   var url = '/newsletter';
//   var email = document.getElementById('newsletter-email').value;
//   var name = document.getElementById('newsletter-name').value;
//   var token = document.getElementsByName('_token')[0].value;

//   fetch(url, {
//     method: 'POST', // or 'PUT'
//     body: JSON.stringify({ 'name': name, 'email': email, '_token': token }), // data can be `string` or {object}!
//     headers:{
//       'Content-Type': 'application/json'
//     }}).then(function(response) {  
//     if (response.status !== 200) {  
//       console.warn('Looks like there was a problem. Status Code: ' + 
//         response.status);
//       return;  
//     }
//     return response.json();
//   }).then(function(data) {  
//       if(data.status!='ok'){
//         $errors = '';
//         for (var i in data.errors) {
//              $errors += data.errors[i][0]+'\n';
//         }
//         return alert('There was a problem with your sign up details\n\n'+$errors);
//       }

//       document.getElementsByClassName('newsletter-form')[0].reset();
//       // Trigger event tracking
//       window.dataLayer = window.dataLayer || [];
//       window.dataLayer.push({
//         'event': 'Newsletter Form Submit'
//       });
//       return alert('Thank you!');

//   }).catch(function(err) {  
//       console.error('Fetch Error -', err);  
//   });


// });



document.addEventListener("DOMContentLoaded", function() {
  //Lazy Load Images
  let lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));
  let active = false;
  const lazyLoad = function() {
    if (active === false) {
      active = true;
      lazyImages.forEach(function(lazyImage) {
        if ((lazyImage.getBoundingClientRect().top <= window.innerHeight && lazyImage.getBoundingClientRect().bottom >= 0) && getComputedStyle(lazyImage).display !== "none") {
          lazyImage.src = lazyImage.dataset.src;
          // lazyImage.srcset = lazyImage.dataset.srcset;
          lazyImage.classList.remove("lazy");

          lazyImages = lazyImages.filter(function(image) {
            return image !== lazyImage;
          });

          if (lazyImages.length === 0) {
            document.removeEventListener("scroll", lazyLoad);
            window.removeEventListener("resize", lazyLoad);
            window.removeEventListener("orientationchange", lazyLoad);
          }
        }
      });
      active = false;
    }
  };
  document.addEventListener("scroll", lazyLoad);
  window.addEventListener("resize", lazyLoad);
  window.addEventListener("orientationchange", lazyLoad);
  lazyLoad();
  //END Lazy Load Images


  // Search Sidebar
  let filterSwitch = document.querySelectorAll('.filter-switch');
  if(filterSwitch){
    Array.prototype.slice.call(filterSwitch, 0).forEach((value) => {
      value.addEventListener('click', () => {
        document.querySelector('#page').classList.toggle('open');
        document.querySelector('.search-results-filters').classList.toggle('open');
        // document.querySelector('.search-results-filters-switch').classList.toggle('open');
      })
    })
  }
  let breadcrumbsSwitch = document.querySelector('.breadcrumbs-search.filter-switch');
  if (breadcrumbsSwitch){
    document.querySelector('#page').classList.add('has-search');
  }
  let searchPage = document.querySelector('.breadcrumbs.search-page');
  if (searchPage){
    document.querySelector('#page').classList.add('search-page');
  }
  // END Search Sidebar

  // Derivative Gallery Slider
  const dealGallerySlider = document.querySelector('.deal-gallery-track');
  if (dealGallerySlider) {
    new Glider(dealGallerySlider, {
      slidesToScroll: 1,
      slidesToShow: 1,
      draggable: true,
      scrollLock: true,
      arrows: {
        prev: '.deal-gallery-controls .glider-prev',
        next: '.deal-gallery-controls .glider-next'
      },
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 1900,
          settings: {
            slidesToShow: 5,
          }
        }
      ]
    })
  }
  // END Derivative Gallery Slider

  // Deal Box Slider
  const dealBoxSlider = [].slice.call(document.querySelectorAll('.latest-offers-strip .latest-offers-strip-ctr .deal-boxes'))
  if (dealBoxSlider) {
    dealBoxSlider.forEach((e) => {
      let sliderID = e.parentElement.parentElement.parentElement.getAttribute('id')
      new Glider(e, {
        slidesToScroll: 1,
        slidesToShow: 1,
        draggable: true,
        scrollLock: true,
        arrows: {
          prev: '.latest-offers-strip#'+sliderID+' .glider-prev',
          next: '.latest-offers-strip#'+sliderID+' .glider-next'
        },
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 1199,
            settings: {
              slidesToShow: 3,
            }
          }
        ]
      })
    })
  }
  // END Deal Box Slider

  // Share Toggle
  const shareContainer = document.querySelector('#share');
  if (shareContainer){
    shareContainer.querySelector('.share-front').addEventListener('click', () => {
      shareContainer.querySelector('.share-front').classList.add('invisible');
      shareContainer.querySelector('.share-back').classList.remove('invisible');
    })
  }
});

// Contact Form
if(document.getElementById('send-contact-form')){
  // Do captcha and submit form

  let button = document.querySelector('#send-contact-form');
  let terms = document.querySelector('#contact-form [name=terms]');
  terms.onchange = function() {
    button.disabled = !this.checked;
  };

  document.getElementById('send-contact-form').addEventListener("click", function(e) {
    e.preventDefault();

    document.body.classList.remove('loaded');

    grecaptcha.ready(function() {
      grecaptcha.execute(document.getElementById('contact-form').dataset['recaptcha'], {action: 'contact'}).then(function(recaptcha_token) {
        document.querySelector('input[name=g-recaptcha-response]').value = recaptcha_token;

        let url = '/contact';
        let email = document.querySelector('#contact-form [name=email]').value;
        let forename = document.querySelector('#contact-form [name=forename]').value;
        let surname = document.querySelector('#contact-form [name=surname]').value;
        let telephone = document.querySelector('#contact-form [name=telephone]').value;
        let comments = `Preferred Date ${document.querySelector('#contact-form [name=date]').value} \n`;
        comments += `Preferred Time ${document.querySelector('#contact-form [name=time]').value} \n`;
        comments += `----\n Additional Info:\n ${document.querySelector('#contact-form [name=comments]').value}`;
        let csrf_token = document.querySelector('#contact-form [name=_token]').value;
        let recaptcha = recaptcha_token;


        fetch(url, {
          method: 'POST',
          body: JSON.stringify({
            'name': forename+' '+surname,
            'forename': forename,
            'surname': surname,
            'email': email,
            'telephone': telephone,
            'comments': comments,
            '_token': csrf_token,
            'g-recaptcha-response': recaptcha
          }),
          headers:{
            'Content-Type': 'application/json'
          }}).then(function(response) {
          document.body.classList.add('loaded');
          if (response.status !== 200) {
            console.warn('Looks like there was a problem. Status Code: ' +
              response.status);
            return;
          }
          return response.json();
        }).then(function(data) {
          if(data.status!='ok'){
            $errors = '';
            for (var i in data.errors) {
              $errors += data.errors[i][0]+'\n';
            }
            return alert('There was a problem with your form\n\n'+$errors);
          }

          document.getElementsByClassName('contact-form')[0].reset();
          document.getElementsByClassName('contact-content')[0].classList.add('hidden');
          document.getElementsByClassName('thank-you')[0].classList.remove('hidden');
          document.getElementsByClassName('contact-details-form')[0].scrollIntoView();

          // Trigger event tracking
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': 'General Enquiry Received'
          });


        }).catch(function(err) {
          document.body.classList.add('loaded');
          console.error('Fetch Error -', err);
          return alert('There was a problem sending your enquiry. Please call us or use our general contact email address.');
        });

      });
    });

  });
}

// Map
if(document.getElementById('map')){

  let map_container = document.getElementById('map');
  let map_zoom = map_container.dataset.zoom;
  let map_lat_center = map_container.dataset.centerLat;
  let map_lng_center = map_container.dataset.centerLng;
  let map_lat = map_container.dataset.lat;
  let map_lng = map_container.dataset.lng;
  let map_lat_2 = map_container.dataset.lat2;
  let map_lng_2 = map_container.dataset.lng2;
  let map_lat_3 = map_container.dataset.lat3;
  let map_lng_3 = map_container.dataset.lng3;

  // Initialize and add the map
  function initMap() {
    var myOptions = {
      center: { lat: parseFloat(map_lat_center), lng: parseFloat(map_lng_center) },
      zoom: parseFloat(map_zoom),
      disableDefaultUI: true,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      styles: [
        {
          "featureType": "all",
          "elementType": "labels",
          "stylers": [
            {
              "visibility": "on"
            }
          ]
        },
        {
          "featureType": "all",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "saturation": 36
            },
            {
              "color": "#000000"
            },
            {
              "lightness": 40
            }
          ]
        },
        {
          "featureType": "all",
          "elementType": "labels.text.stroke",
          "stylers": [
            {
              "visibility": "on"
            },
            {
              "color": "#000000"
            },
            {
              "lightness": 16
            }
          ]
        },
        {
          "featureType": "all",
          "elementType": "labels.icon",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "administrative",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#000000"
            },
            {
              "lightness": 20
            }
          ]
        },
        {
          "featureType": "administrative",
          "elementType": "geometry.stroke",
          "stylers": [
            {
              "color": "#000000"
            },
            {
              "lightness": 17
            },
            {
              "weight": 1.2
            }
          ]
        },
        {
          "featureType": "administrative.country",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#838383"
            }
          ]
        },
        {
          "featureType": "administrative.locality",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#c4c4c4"
            }
          ]
        },
        {
          "featureType": "administrative.neighborhood",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#aaaaaa"
            }
          ]
        },
        {
          "featureType": "landscape",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#000000"
            },
            {
              "lightness": 20
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#000000"
            },
            {
              "lightness": 21
            },
            {
              "visibility": "on"
            }
          ]
        },
        {
          "featureType": "poi.business",
          "elementType": "geometry",
          "stylers": [
            {
              "visibility": "on"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#6e6e6e"
            },
            {
              "lightness": "0"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "geometry.stroke",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#ffffff"
            }
          ]
        },
        {
          "featureType": "road.arterial",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#000000"
            },
            {
              "lightness": 18
            }
          ]
        },
        {
          "featureType": "road.arterial",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#575757"
            }
          ]
        },
        {
          "featureType": "road.arterial",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#ffffff"
            }
          ]
        },
        {
          "featureType": "road.arterial",
          "elementType": "labels.text.stroke",
          "stylers": [
            {
              "color": "#2c2c2c"
            }
          ]
        },
        {
          "featureType": "road.local",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#000000"
            },
            {
              "lightness": 16
            }
          ]
        },
        {
          "featureType": "road.local",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#999999"
            }
          ]
        },
        {
          "featureType": "transit",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#000000"
            },
            {
              "lightness": 19
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#000000"
            },
            {
              "lightness": 17
            }
          ]
        }
      ]
    };

    var map = new google.maps.Map( map_container, myOptions );
    if (map_lat && map_lng) {
      var marker = new google.maps.Marker({
        position: { lat: parseFloat(map_lat), lng: parseFloat(map_lng) },
        map: map,
        icon: { url: '/themes/crusadercars/img/icons/marker.svg', scaledSize: new google.maps.Size(100, 100) }
      });
    }
    if (map_lat_2 && map_lng_2) {
      var marker2 = new google.maps.Marker({
        position: { lat: parseFloat(map_lat_2), lng: parseFloat(map_lng_2) },
        map: map,
        icon: { url: '/themes/crusadercars/img/icons/marker.svg', scaledSize: new google.maps.Size(100, 100) }
      });
    }
    if (map_lat_3 && map_lng_3) {
      var marker3 = new google.maps.Marker({
        position: { lat: parseFloat(map_lat_3), lng: parseFloat(map_lng_3) },
        map: map,
        icon: { url: '/themes/crusadercars/img/icons/marker.svg', scaledSize: new google.maps.Size(100, 100) }
      });
    }
  }
}

// Subscribe Form
if(document.getElementById('email-signup')){
  document.getElementById('email-signup').addEventListener("click", function(e) {
    e.preventDefault();

    var recaptcha_token = null;

    if(document.querySelector('input[name=g-recaptcha-response]')){
      recaptcha_token = document.querySelector('input[name=g-recaptcha-response]').value;
    } else {
      grecaptcha.execute(document.getElementById('contact-form').dataset['recaptcha'], {action: 'contact'}).then(function(token) {
        recaptcha_token = token;
      });
    }

    document.getElementById('email-signup').classList.add('preload');
    document.getElementById('email-signup').innerHTML = '<span class="btn-loading">Please wait<span>';
    document.getElementById('email-signup').disabled = true;

    let url = (typeof $base_path !== 'undefined' ? $base_path : '')+'/newsletter';
    let email = document.getElementById('newsletter-email').value;
    let name = document.getElementById('newsletter-name').value;
    let token = document.getElementsByName('_token')[0].value;

    fetch(url, {
      method: 'POST', // or 'PUT'
      body: JSON.stringify({ 'name': name, 'first_name': name, 'email': email, 'mail_status': 'subscribed', '_token': token }), // data can be `string` or {object}!
      headers:{
        'Content-Type': 'application/json'
      }}).then(function(response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' +
          response.status);
        return;
      }
      return response.json();
    }).then(function(data) {
      document.getElementById('email-signup').classList.remove('preload');
      document.getElementById('email-signup').innerHTML = 'Signup';
      document.getElementById('email-signup').disabled = false;

      if(data.status!='ok'){
        let errors = '';
        for (var i in data.errors) {
          errors += data.errors[i][0]+'\n';
        }
        if(typeof Swal !== 'undefined'){
          return Swal.fire({
            title: 'Whoops!',
            html: ('There was a problem with your sign up details\n\n'+$errors).replace(/\n/gi,'<br>'),
            icon: 'error',
            confirmButtonText: 'OK',
          });
        } else {
          return alert('There was a problem with your sign up details\n\n'+$errors);
        }
      }

      document.getElementsByClassName('newsletter-form')[0].reset();
      // Trigger event tracking
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'Newsletter Signup'
      });

      if(typeof Swal !== 'undefined'){
        return Swal.fire({
          title: 'Thank you!',
          text: 'You\'re signed up!',
          icon: 'success',
          confirmButtonText: 'OK'
        });
      } else {
        return alert('Thank you!');
      }

    }).catch(function(err) {
      console.error('Fetch Error -', err);
      document.getElementById('email-signup').classList.remove('preload');
      document.getElementById('email-signup').innerHTML = 'Signup';
      document.getElementById('email-signup').disabled = false;
    });
  });
}

window.onload = (function(){
  //preloader
  document.querySelector('html').classList.add("site-loaded");
  document.body.classList.add("loaded");
  setTimeout(() => { document.querySelector('.loader-ctr').remove() }, 500)


  function loadSearchForm () {
    // Load Search searchType
    if(document.getElementsByClassName('search-form').length>0){
      // Search
      let searchType = document.querySelector('#search-type').value;
      loadManufacturers(searchType);
      loadBodyTypes(searchType, true);

      document.querySelector('.search-form [name=search-type]').addEventListener("change", function(e){
        loadManufacturers(this.value, e.target.value);
        loadBodyTypes(this.value, true);
      });

      document.querySelector('.search-form [name=make]').addEventListener("change", function(e){
        searchType = document.querySelector('#search-type').value;
        loadModels(searchType, e.target.value);
      });

      document.querySelector('.search-form [name=model]').addEventListener("change", function(e){
        searchType = document.querySelector('#search-type').value;
        document.querySelector('.search-form [name=spec_level]') ? loadSpecs(searchType, e.target.value) : null;
      });
    }
  }
  loadSearchForm();

  
});